import menuTypes from '../enum/enum';

const actions = {
    changeSelectTab ({ commit }, { selectVal, userId }) {
        commit('changeSelectTab', { selectVal, userId });
        commit('changeTitle', menuTypes[selectVal]);
    },
    selectFansBy ({ commit }, selectFansBy) {
        commit('selectFansBy', selectFansBy);
    },
    selectRankBy ({ commit }, selectRankBy) {
        commit('selectRankBy', selectRankBy);
    },
    setShowFooter ({ commit }, value) {
        commit('setShowFooter', value);
    }
};

export default actions;


// WEBPACK FOOTER //
// ./src/actions/interface.js